import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../stores/redux-store';
import { ConsumedHandoffSession } from '../../models/handoffSession';
import { LoadingOverlay } from '../../core/screens/LoadingOverlay/LoadingOverlay';
import { fetchCredentials as fetchCredentialsConnect } from '../../connectivity/services/credentials';

export type HandoffCredentialsFinderProps = PropsFromRedux;

export const HandoffCredentialsFinderPresenter: React.FC<HandoffCredentialsFinderProps> = ({
  children,
  handoffSession,
  credentials,
  fetchCredentials,
}) => {
  const { credentialsId } = handoffSession;

  useEffect(() => {
    if (credentialsId && !credentials) {
      fetchCredentials({ credentialsId });
    }
  }, [fetchCredentials, credentialsId, credentials]);

  if (!credentials) {
    return <LoadingOverlay />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

const mapStateToProps = (state: AppState) => {
  return {
    handoffSession: state.handoffSession.data as ConsumedHandoffSession,
    credentials: state.credentials.data,
  };
};

const mapDispatchToProps = { fetchCredentials: fetchCredentialsConnect };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export const HandoffCredentialsFinder = connector(HandoffCredentialsFinderPresenter);
